var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCancel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.79 5.42a2.212 2.212 0 01-2.21-2.21V.343l5.077 5.076H12.79zm-2.332 6.468a.405.405 0 010 .58l-1.356 1.346a.412.412 0 01-.584 0l-2.226-2.23-2.23 2.23a.412.412 0 01-.584 0l-1.356-1.346a.405.405 0 010-.58L4.37 9.68 2.122 7.467a.405.405 0 010-.58L3.478 5.54a.412.412 0 01.585 0l2.229 2.23 2.226-2.23a.412.412 0 01.584 0l1.356 1.345a.405.405 0 010 .58L8.212 9.68l2.246 2.21zM10.666 0H2.58A2.588 2.588 0 000 2.58v10.84C0 14.838 1.161 16 2.58 16h10.84c1.419 0 2.58-1.161 2.58-2.58V5.333L10.666 0z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCancel);
export default ForwardRef;